module.exports = __webpack_public_path__ + "static/media/kids_58.aecfb47c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_58.jpg
// module id = 5914
// module chunks = 0